// 项目管理页面路由
const XmglList = () => import('@/views/xmgl/index.vue');

export default [
  {
    path: '/xmgl',
    name: 'xmgl',
    meta: {
      title: '项目管理',
      icon: 'el-icon-s-management',
      noCache: false,
      affix: true
    },
    component: XmglList
  }
];
